import { render, staticRenderFns } from "./ScanGoods.vue?vue&type=template&id=4a46c8ef&scoped=true&"
import script from "./ScanGoods.vue?vue&type=script&lang=js&"
export * from "./ScanGoods.vue?vue&type=script&lang=js&"
import style0 from "./ScanGoods.vue?vue&type=style&index=0&id=4a46c8ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a46c8ef",
  null
  
)

export default component.exports